export const size = {
    mobile: 576,
    tablet: 768,
    laptop: 992,
    desktop: 1200,
}

export const device = {
    mobile: `(min-width: ${size.mobile}px)`,
    tablet: `(min-width: ${size.tablet}px)`,
    laptop: `(min-width: ${size.laptop}px)`,
    desktop: `(min-width: ${size.desktop}px)`,
}
